import { triggerDownload } from "../common/services/PreregistroService";
import { setAttributesAdsBlog } from "../components/ads";
import { setOrigen } from "../components/script";
import { shareEmail, shareFacebook, shareUrl, shareWhatsapp } from "../components/shareFunctions";
import { scrollRight } from "../partials/scrollNav";
window.showCesantiasForm = showCesantiasForm;
window.showPrimaForm = showPrimaForm;
window.shareUrl = shareUrl;
window.shareWhatsapp = shareWhatsapp;
window.shareFacebook = shareFacebook;
window.shareEmail = shareEmail;
window.scrollRight = scrollRight;
// load Ads
let origen = 'Blog';
setAttributesAdsBlog();
// title tags blog
const phrases = document.querySelectorAll('.field--name-name');
phrases.forEach((phrase) => {
    const words = phrase.innerHTML.split(' ');
    words[0] = `<span>${words[0]}</span>`; // this would return the second word
    phrase.innerHTML = words.join(' ');
});
function showCesantiasForm() {
    var _a;
    const sent = sessionStorage.getItem('sent-form-blog') === 'true';
    if (!sent) {
        const form = document.querySelector('.js-form-blog');
        if (form) {
            form.classList.add('form-highlighted');
            const y = form.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: y - 150,
                behavior: 'smooth',
            });
            document.getElementById("blogFormTitle").innerHTML = "Regístrate y descarga el modelo de carta gratis";
            (_a = document.getElementById("message-cesantias")) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
            setOrigen('Blog - Cesantías');
        }
    }
    else {
        triggerDownload("https://www.estrenarvivienda.com/sites/default/files/2026-02/modelo_carta_cesantias_2026.docx");
    }
}
function showPrimaForm() {
    var _a;
    const sent = sessionStorage.getItem('sent-form-blog') === 'true';
    if (!sent) {
        const form = document.querySelector('.js-form-blog');
        if (form) {
            form.classList.add('form-highlighted');
            const y = form.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: y - 150,
                behavior: 'smooth',
            });
            document.getElementById("blogFormTitle").innerHTML = "Regístrate y descarga el plan de pagos gratis";
            (_a = document.getElementById("message-prima")) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
            setOrigen('Blog - Prima');
        }
    }
    else {
        triggerDownload("https://www.estrenarvivienda.com/sites/default/files/2026-07/Plantilla%20Plan%20de%20pago%20-%20Estrenar%20Vivienda.xlsx");
    }
}
// Article Section
document.addEventListener("DOMContentLoaded", function () {
    let paragraphs = Array.from(document.querySelectorAll('.editor-content > p'));
    let externalLinks = Array.from(document.querySelectorAll('.editor-content a'));
    if (externalLinks.length > 0) {
        externalLinks.forEach(itemLink => {
            itemLink.setAttribute('target', '_blank');
        });
    }
    let node = document.getElementById('articleTypologies');
    if (paragraphs.length > 0 && node) {
        paragraphs.forEach(paragraph => {
            if (paragraph.innerHTML == 'mostrar_proyectos_de_interes') {
                paragraph.innerHTML = "";
                paragraph.appendChild(node);
            }
        });
    }
    let cesantiasBanner = document.getElementById("cesantiasButton");
    let compensarBanner = document.getElementById("compensarButton");
    let primaBanner = document.getElementById("primaButton");
    if (paragraphs.length > 0) {
        paragraphs.forEach(paragraph => {
            if (cesantiasBanner && paragraph.innerHTML.includes('mostrar_boton_cesantias')) {
                paragraph.innerHTML = "";
                paragraph.appendChild(cesantiasBanner);
                cesantiasBanner.classList.add("d-flex");
            }
            if (compensarBanner && paragraph.innerHTML.includes('mostrar_boton_compensar')) {
                paragraph.innerHTML = "";
                paragraph.appendChild(compensarBanner);
                compensarBanner.classList.add("d-flex");
            }
            if (primaBanner && paragraph.innerHTML.includes('mostrar_boton_prima')) {
                paragraph.innerHTML = "";
                paragraph.appendChild(primaBanner);
                primaBanner.classList.add("d-flex");
            }
        });
    }
    const floatIframe = document.getElementById("avi-chat-float-frame");
    if (floatIframe === null || floatIframe === void 0 ? void 0 : floatIframe.contentWindow) {
        floatIframe.contentWindow.postMessage({
            type: "AVI_ORIGIN",
            payload: {
                origin: "AVI - Blog",
            },
        }, "*");
    }
});
